'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutDown = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '100%', 0)
  }
};
exports.default = fadeOutDown;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-down.js
// module id = 758
// module chunks = 0